import { gql } from '@apollo/client';

export const getTownships = gql`
  query getTownships {
    getTownships {
      id
      state
      county
      township
    }
  }
`;
